module.exports = __webpack_public_path__ + "static/media/img1.8e84ee8a.png";